import React from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { getDashboardConfig } from "../config";
import { getTenantType } from "../tenant/tenant";

/**
 * Cabecera + contenedor comun de cada vista (.vhead): kick (nombre de la vista)
 * + titular + descripcion. Rellena el alto (flex).
 *
 * El kick se omite en farma: su nav ya va mas anidada (grupo > vista), asi que
 * repetir el nombre de la vista aqui era redundante. En clinica se mantiene.
 */
function ViewContainer({ title, description, children }) {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const { views: dashboardViews } = getDashboardConfig();
    const view = dashboardViews.find((v) => v.path === pathname);
    const kick = view && getTenantType() !== "farma" ? t(`nav.${view.key}`) : null;

    return (
        <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            <Box sx={{ mb: { xs: 1.5, md: 1.75 }, flexShrink: 0 }}>
                {kick && (
                    <Typography
                        sx={{
                            fontSize: 12,
                            fontWeight: 500,
                            letterSpacing: "0.06em",
                            textTransform: "uppercase",
                            color: "primary.main",
                            mb: 0.5,
                        }}
                    >
                        {kick}
                    </Typography>
                )}
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{ color: "text.primary", fontSize: { xs: "1.4rem", md: "1.65rem" }, lineHeight: 1.18 }}
                >
                    {title}
                </Typography>
                {description && (
                    <Typography sx={{ mt: 0.5, fontSize: 13.5, color: "text.secondary", maxWidth: "66ch", lineHeight: 1.45 }}>
                        {description}
                    </Typography>
                )}
            </Box>
            <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>{children}</Box>
        </Box>
    );
}

export default ViewContainer;
